/* eslint-disable no-unused-vars */
import React, { forwardRef, useEffect, useState } from "react";
import PropTypes from "prop-types";

import Container from "../Container";
import useGames from "./useGames";
import useIframeHeight from "./useIframeHeight";
import { useRef } from "react";
import Loader from "../../components/loader/Loader";
import { useSelector } from "react-redux";
import Widgets from "../Lobby/Widgets";
import { getSetParams } from "../../classes/utills";
import Toggle from "../../components/toggle/Toggle";
import lang from "../../classes/lang";
import { go } from "../../classes/routesLazy";
// import { Icon } from "react-icons-kit";
// import { close } from "react-icons-kit/fa/close";
// import { expand } from "react-icons-kit/fa/expand";
// import { compress } from "react-icons-kit/fa/compress";

// eslint-disable-next-line no-unused-vars
const FlappyBetGame = forwardRef((props, ref) => {
	FlappyBetGame.propTypes = {
		match: PropTypes.object,
		showWidget: PropTypes.bool,
	};
	const refIframe = useRef(null);
	const coinSelected = useSelector((store) => store.coin.selected);
	const langRoute = useSelector((store) => store.langRoute);
	const un = useSelector((store) => store.player.userName);
	const { init, url } = useGames({ coinSelected });
	const [loaded, setLoaded] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [expanded, setExpanded] = useState(false);
	const isDemo = props.match?.params?.isdemo !== "real";
	const isBattle = typeof window !== "undefined" && window.location.pathname.indexOf("/battle/") !== -1;
	useEffect(() => {
		getSetParams();
	}, []);
	useEffect(() => {
		if (url) {
			refIframe.current.onload = () => {
				setLoaded(true);
			};
		} else {
			setLoaded(false);
		}
	}, [url]);

	const getReal = () => {
		if (typeof window === "undefined") return null;
		if (un === "guest") return null;
		if (window.location.pathname.indexOf("/originals/") === -1) return false;
		return true;
	};
	const onSwitchMode = () => {
		if (!loaded) return;
		// go(`crypto-slots/${!isDemo ? "demo" : "real"}/${uuid}/${name}`);
		go(`originals/${props.match?.params?.gamename}/${props.match?.params?.gameid}/${!isDemo ? "demo" : "real"}`);
		// window.location.href = `/originals/${props.match?.params?.gamename}/${props.match?.params?.gameid}/${!isDemo ? "demo" : "real"}`
	};
	const run = async () => {
		const id = +props.match?.params?.gameid;
		if (!(id > 0)) return;
		await init(id, isDemo);
	};

	useEffect(() => {
		run();
	}, [coinSelected, langRoute, isDemo]);

	//Request and set iframe height:
	const { iframeHeight, isFixed } = useIframeHeight({ refIframe, url });
	const style = { width: "100%", height: isFixed ? "600px" : iframeHeight };
	const _url = url?.replace("5173", "5174");
	return (
		<Container
			className="flappyBetGame"
			style={{
				...(props.showWidget === false ? { paddingBottom: 0 } : {}),
			}}
		>
			<>
				{!loaded && (
					<div style={{ position: "relative", width: "100%", height: "520px" }}>
						<Loader />
					</div>
				)}
				{url ? (
					<>
						{/* <button className="btnDefault warn btnFlappyExpand" onClick={(e) => [e.stopPropagation(), setExpanded((prev) => !prev)]}>
							<b>+</b>
						</button> */}
						<iframe ref={refIframe} id="iframeFlappy" src={_url} style={style} className={`${expanded ? "expanded" : ""}`} />
						{!isBattle && (
							<div className="btns">
								{/* {un === "admini" && (
							<button onClick={(e) => [e.stopPropagation(), onValidate()]} className="btnDefault btnValidate">
								SELF-VALIDATE
							</button>
						)} */}
								{!expanded && (
									<div className="toggleWrapper">
										<b>{lang.translate("demo")}</b>
										{typeof getReal() === "boolean" && (
											<Toggle disabled={!loaded || un === "guest"} on={""} off={""} value={getReal()} onChange={onSwitchMode} />
										)}
										<b>{lang.translate("real")}</b>
									</div>
								)}
								{/* <button onClick={(e) => [e.stopPropagation(), onExpandToggle()]} className="btnIcon small btnExpand">
								<Icon icon={expanded ? compress : expand} size={24} />
							</button>
							{!expanded && (
								<button onClick={(e) => [e.stopPropagation(), onCloseGame()]} className="btnIcon small btnClose">
									<Icon icon={close} size={24} />
								</button>
							)} */}
							</div>
						)}
					</>
				) : (
					<Loader />
				)}
				{!(props.showWidget === false) && <Widgets activeTab="my_bets" />}
			</>
		</Container>
	);
});
FlappyBetGame.displayName = "FlappyBetGame";
export default FlappyBetGame;
